<template>
    <v-form @submit.prevent="searchUser" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold">Add new employee</span>
                <v-spacer></v-spacer>
                <help-link appId="company" pageId="employees-add" color="black"></help-link>
                <v-btn icon @click.native="closeDialog(null)" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text style="padding: 20px 40px 20px 40px;">
                <v-layout>
                    <v-flex xs12>
                        <v-alert v-if="error" type="warning" dismissible>
                            {{ errorMessage }}
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-alert :value="true" color="info" icon="info" outline >
                            Enter new employee's email then click Verify to continue.
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 style="margin-top:20px;">                
                        <v-text-field label="Enter email" 
                            v-model="email" 
                            :rules="[rules.required, rules.email]"
                            @keyup="searchStatus=0;"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>          
                <v-layout v-if="searchStatus==5" row wrap> 
                    <v-flex xs12>  
                        <v-alert :value="true" color="warning" icon="warning" outline>
                            Email <b>{{email}}</b> already exist in your Company.
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout v-if="searchStatus==4" row wrap> 
                    <!-- Email already exist in SweldoNow DB -->
                    <v-flex xs12>  
                        <v-alert :value="true" color="warning" icon="warning" outline>
                            Email <b>{{email}}</b> already exist in other Company.
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="searchStatus>0" :loading="loading" style="color:white;margin-right:25px;">Verify</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import userApi from '@/api/user'

export default {
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        return {
            email: null,
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            searchStatus: 0
        }
    },
    methods: {
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        },
        async searchUser() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    const response = await userApi.search(this.email)
                    if (response && response.status == 200) {
                        this.searchStatus = response.data 
                        if (response.data == 1) {
                            this.$emit('update:dialogAddUserOptions', false)
                            this.$emit('send', this.email)
                        }
                    }
                }
                this.loading = false
                this.disabled = false
            }
            catch (error) {
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog(addby) {
            this.$emit('send', addby)
            this.$emit('update:dialogAddUserOptions', false)
        },
    },
    computed: {},
    created() {}
}
</script>